import type { UnitLabelMap } from '../../IntervalConfigRow/components/UnitToggle/types';

type UnitLabelStrings = {
    CHARGE_CYCLES: string;
    UNIT_FLIGHTS: string;
    UNIT_HOURS: string;
};

export const getUnitLabels = (strings: UnitLabelStrings): UnitLabelMap => ({
    cycles: strings.CHARGE_CYCLES,
    flights: strings.UNIT_FLIGHTS,
    hours: strings.UNIT_HOURS
});
